import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CurrentUserService } from '@services/current-user/current-user.service';
import { MasterDataService } from '@services/masterData/master-data.service';

@Component({
  selector: 'global-billing-receipt-modal',
  templateUrl: './billing-receipt-modal.component.html',
  styleUrls: ['./billing-receipt-modal.component.scss']
})
export class BillingReceiptModalComponent implements OnInit {

  @ViewChild("billingReceiptModal") billingReceiptModal: TemplateRef<any>;
  billing_details: any;
  constructor(private modalService: NgbModal,
    private currentUser: CurrentUserService,
    public masterService: MasterDataService) { }

  ngOnInit(): void {

  }

  /* Open Modal */
  openModal(billing, api: any) {
    this.masterService.billingReceipt(billing.id, api)
      .subscribe(res => {
        if (res['data']) {
          this.billing_details = res['data'];
          // console.log(this.billing_details);
          this.modalService.open(this.billingReceiptModal, {
            windowClass: "modal",
            centered: true,
            size: "xl",
          });
        }
      })
  }
  /* Print Billing Recipt*/
  print() {
    const printContent = document.getElementById("billingPrint");
    const WindowPrt = window.open('', '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
    WindowPrt.document.write(printContent.innerHTML);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();
    WindowPrt.close();
  }
}
